export default {
    MenuProductList: (data) => window.axios.get(`restaurants/${data.restaurant_id}/category/${data.menu_category_id}/menu-items`, data),
    RestaurantMenusItemDetails: (data) => window.axios.get(`item/${data.item_id}`, data),
    // RestaurantInfo: (data) => window.axios.post('get_restaurant_detail', data),
    restaurantMenusList: (data) => window.axios.post('restaurantmenus', data),
    getRestaurantCategoryWithMenu: (data) => window.axios.post('restaurantCategoryWithMenu', data),
}